import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-contact-popup',
  templateUrl: './contact-popup.component.html',
  styleUrls: ['./contact-popup.component.scss']
})
export class ContactPopupComponent {
  @HostBinding('class.show-close-icon') closeIcon: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

}